export class ModuleConfiguration {
  static moduleName = 'customer';
}



// WEBPACK FOOTER //
// ./src/app/customer/customer.module.config.ts